export default __webpack_public_path__ + "static/media/gini.4f2b2495.png";